module.exports = "/_next/static/files/f2c5552d1c51988c09be4bfefaaf7e51.png";